import { useTranslation } from "react-i18next";
import logo from "../../../assets/logo.png";

export default function Classificacao() {
  const { t } = useTranslation();
  return (
    <section id="classificacao-section" className="section_inicial">
      <div className="imagem-texto">
        <h1>{t("producao.classificacao.titulo")}</h1>
        <img src={logo} alt="Logo GranCaju" />
      </div>
      <p
        dangerouslySetInnerHTML={{
          __html: t("producao.classificacao.descricao")
        }}
      />
    </section>
  );
}
